import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {LienTache} from '../../../../models/taches/gestion-taches.model';
import {EntrepriseModel} from '../../../../models/entreprise/entreprise.model';
import {EntreprisesService} from '../../../../services/entreprises/entreprises.service';
import {Subscription} from 'rxjs';
import {base64string} from '../../../../utils/file-conversions-util';

@Component({
  selector: 'app-lien-entreprise-details-tooltip',
  templateUrl: './lien-entreprise-details-tooltip.component.html',
  styleUrls: ['./lien-entreprise-details-tooltip.component.scss']
})
export class LienEntrepriseDetailsTooltipComponent implements OnInit , OnDestroy{
  @Input() set lien(value: LienTache) {
    if (value != null) {
      this.idEntreprise = value.idOriginal;
      this.loadEntreprise(this.idEntreprise)
      this.loadLogo()
    }
  }
  private idEntreprise: number = null;
  public entreprise: EntrepriseModel;
  public logoData: base64string;
  public sub: Subscription[] = [];

  constructor(private entrepriseService: EntreprisesService) { }

  ngOnInit(): void {
  }
  
  ngOnDestroy(): void {
    this.sub.map(ob => ob.unsubscribe());
  }

  get hasVille(): boolean {
    return this.entreprise?.ville != null
  }

  private loadEntreprise(id: number) {
    this.sub.push(
      this.entrepriseService.getEntrepriseDetaillee(id).subscribe(entreprise => {
        this.entreprise = entreprise
      })
    );
  }

  private loadLogo() {
    this.sub.push(
      this.entrepriseService.chargerLogo(this.idEntreprise).subscribe(photoData => this.logoData = photoData)
    );
  }


}
